import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function DatabasePostgreSQL() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const postgresServices = [
        "Installazione e configurazione PostgreSQL",
        "Performance tuning e query optimization",
        "Streaming replication setup",
        "Logical replication configuration",
        "Advanced backup strategies (PITR)",
        "Extension management (PostGIS, TimescaleDB)",
        "Connection pooling con PgBouncer",
        "Database migration e upgrade"
    ];

    const advancedFeatures = [
        "JSON/JSONB optimization",
        "Full-text search implementation",
        "Partitioning strategies",
        "Custom data types creation",
        "Stored procedures e functions",
        "Trigger optimization",
        "Window functions tuning",
        "CTE (Common Table Expressions) optimization"
    ];

    const highAvailability = [
        "Master-Standby hot replication",
        "Multi-master con BDR/Postgres-XL",
        "Patroni cluster management",
        "Automatic failover con etcd/Consul",
        "Load balancing con HAProxy",
        "Cross-region replication",
        "Point-in-time recovery (PITR)",
        "WAL archiving e restore"
    ];

    const securityCompliance = [
        "Row Level Security (RLS)",
        "SSL/TLS encryption",
        "Audit logging con pgAudit",
        "Data encryption at rest",
        "Role-based access control",
        "Password policies enforcement",
        "LDAP/Active Directory integration",
        "Compliance reporting (SOX, HIPAA)"
    ];

    const monitoringTools = [
        "pg_stat_statements analysis",
        "pgAdmin monitoring",
        "Prometheus + Grafana dashboards",
        "Custom metrics collection",
        "Slow query identification",
        "Connection monitoring",
        "Lock analysis e troubleshooting",
        "Capacity planning e forecasting"
    ];

    const extensionsEcosystem = [
        "PostGIS for geospatial data",
        "TimescaleDB for time-series",
        "Citus for horizontal scaling",
        "pg_cron for scheduled jobs",
        "uuid-ossp for UUID generation",
        "hstore for key-value storage",
        "Foreign Data Wrappers (FDW)",
        "Custom extensions development"
    ];

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Database PostgreSQL</h1>
                    <p className="service-description">
                        Amministrazione avanzata PostgreSQL con performance optimization,
                        alta disponibilità e soluzioni enterprise per applicazioni mission-critical.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={8}>
                            <div className="service-description">
                                <h3>PostgreSQL Enterprise Administration</h3>
                                <p>
                                    Amministro database PostgreSQL con competenza avanzata su funzionalità
                                    enterprise, garantendo prestazioni ottimali, sicurezza robusta e
                                    scalabilità per applicazioni web complesse e data warehouse.
                                </p>
                                <p>
                                    Dalla configurazione di cluster ad alta disponibilità all'implementazione
                                    di soluzioni geospaziali con PostGIS, offro expertise completa
                                    sull'ecosistema PostgreSQL per ogni tipo di workload.
                                </p>
                            </div>

                            <div className="postgres-services">
                                <h3>Servizi PostgreSQL</h3>
                                <Row>
                                    {postgresServices.map((service, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🐘</span>
                                                {service}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="advanced-features-section">
                                <h3>Funzionalità Avanzate</h3>
                                <Row>
                                    {advancedFeatures.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">⚡</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <Alert variant="success" className="postgres-alert">
                                <h5><i className="fas fa-rocket"></i> Advanced SQL Features</h5>
                                <p>
                                    Sfrutto le funzionalità SQL avanzate di PostgreSQL come window functions,
                                    CTE ricorsive, JSONB operations e full-text search per query complesse
                                    e analisi dati sofisticate.
                                </p>
                            </Alert>

                            <div className="ha-section">
                                <h3>Alta Disponibilità e Replication</h3>
                                <Row>
                                    {highAvailability.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🔄</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="security-section">
                                <h3>Sicurezza e Compliance</h3>
                                <Row>
                                    {securityCompliance.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🔒</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="extensions-section">
                                <h3>Extensions e Ecosistema</h3>
                                <Row>
                                    {extensionsEcosystem.map((extension, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🧩</span>
                                                {extension}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="monitoring-section">
                                <h3>Monitoring e Performance Analysis</h3>
                                <Row>
                                    {monitoringTools.map((tool, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">📊</span>
                                                {tool}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Metodologia Gestione PostgreSQL</h3>
                                <div className="process-steps">
                                    <div className="process-step-item">
                                        <div className="step-number">1</div>
                                        <div className="step-text">Analysis workload e requirements specifici</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">2</div>
                                        <div className="step-text">Design architettura e security hardening</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">3</div>
                                        <div className="step-text">Setup replication, backup e monitoring</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">4</div>
                                        <div className="step-text">Tuning continuo e manutenzione proattiva</div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Piani PostgreSQL</h4>
                                        <div className="pricing-plan">
                                            <h5>PostgreSQL Basic</h5>
                                            {/* <div className="plan-price">€180/mese</div> */}
                                            <ul>
                                                <li>1 Database instance</li>
                                                <li>Basic performance tuning</li>
                                                <li>Backup automatici</li>
                                                <li>Monitoring essenziale</li>
                                                <li>Supporto 9-18</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan featured">
                                            <h5>PostgreSQL Professional</h5>
                                            {/* <div className="plan-price">€350/mese</div> */}
                                            <ul>
                                                <li>Fino a 3 instances</li>
                                                <li>Streaming replication</li>
                                                <li>Advanced monitoring</li>
                                                <li>Extensions management</li>
                                                <li>Monitoring 24/7</li>
                                                <li>Support prioritario</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan">
                                            <h5>PostgreSQL Enterprise</h5>
                                            {/* <div className="plan-price">€600/mese</div> */}
                                            <ul>
                                                <li>Multi-master clusters</li>
                                                <li>High availability setup</li>
                                                <li>Advanced security</li>
                                                <li>Custom extensions</li>
                                                <li>DBA dedicato</li>
                                                <li>SLA 99.9%</li>
                                            </ul>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card className="postgres-versions-card">
                                    <Card.Body>
                                        <h4>📋 Versioni e Distribuzioni</h4>
                                        <ul>
                                            <li>PostgreSQL 15 (Latest)</li>
                                            <li>PostgreSQL 14 (Stable)</li>
                                            <li>PostgreSQL 13 (LTS)</li>
                                            <li>Amazon RDS PostgreSQL</li>
                                            <li>Google Cloud SQL</li>
                                            <li>Azure Database for PostgreSQL</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="specializations-card">
                                    <Card.Body className="text-center">
                                        <h5>🎯 Specializzazioni</h5>
                                        <ul style={{textAlign: 'left'}}>
                                            <li>GIS con PostGIS</li>
                                            <li>Time-series con TimescaleDB</li>
                                            <li>Data warehousing</li>
                                            <li>JSON/NoSQL workloads</li>
                                            <li>Analytics avanzate</li>
                                            <li>Real-time applications</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="tools-ecosystem-card">
                                    <Card.Body className="text-center">
                                        <h5>🛠️ Tools Ecosystem</h5>
                                        <ul style={{textAlign: 'left'}}>
                                            <li>pgAdmin 4</li>
                                            <li>pgBouncer connection pooling</li>
                                            <li>Patroni cluster management</li>
                                            <li>pgBackRest backup</li>
                                            <li>pg_stat_statements</li>
                                            <li>WAL-E/WAL-G archiving</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <a href="#contact" className="btn-gradient w-100 mb-3">
                                        <span>Richiedi Preventivo PostgreSQL</span>
                                    </a>
                                    <Link to="/services" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
            </Container>
        </div>
    );
}

export default DatabasePostgreSQL;